import { useRef } from "react"
import { t } from "i18next"
import { toast } from "react-toastify"

function useLoadingToast({ isRefetching, isPlaceholderData }) {
  const toastId = useRef("toast")
  if (isRefetching && isPlaceholderData) {
    toastId.current = toast.loading(t("loading"), { position: "top-center" })
  } else {
    toast.dismiss(toastId.current)
  }
  return {
    isRefetching,
    isPlaceholderData,
  }
}

export default useLoadingToast
